import axios, { AxiosResponse, CancelTokenSource } from 'axios'
import {
  IInsuranceCasesFilter,
  IInsuranceCasesResultModel,
} from 'Modules/HousingAssociation/Insurance/shared/models/Cases'
import {
  ITenantsFilters,
  TenantsSortFieldEnum,
} from 'Modules/HousingAssociation/Tenants/shared/models/Tenants'
import { IExportRequestModel, IUnitFilter } from '../models/Unit'
import { ISortOrderEnum } from 'shared/models/List'

const defaultHeaders = {
  'x-api-version': '2.0',
}

export const getUnits = (filters: IUnitFilter) => {
  return axios.post(`hu/client/${filters.clientId}/units`, filters, {
    headers: defaultHeaders,
  })
}

export const getUnit = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}`, { headers: { 'x-api-version': '2.0' } })
}

export const getClientAddresses = (clientId: any) => {
  return axios.get(`hu/Client/${clientId}/addresses`, {
    headers: defaultHeaders,
  })
}

export const getTenants = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}/tenants`, {
    headers: defaultHeaders,
  })
}

export const getCurrentJointCost = (unitId: any) => {
  // Get next 12 months (starting from this one)
  const fromDate = new Date()
  fromDate.setDate(1)

  const toDate = new Date()
  toDate.setDate(1)
  toDate.setFullYear(fromDate.getFullYear() + 1)
  toDate.setMonth(fromDate.getMonth() - 1)
  return axios.get(
    `hu/unit/${unitId}/jointcostpersonal?isBoardPortal=true&fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    {
      headers: defaultHeaders,
    }
  )
}

export const getOwners = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}/owners`, {
    headers: defaultHeaders,
  })
}

export const getCohaibitants = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}/residents`, {
    headers: defaultHeaders,
  })
}

export const getObjects = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}/objects`, {
    headers: defaultHeaders,
  })
}

export const getMeters = (unitId: any) => {
  return axios.get(`hu/unit/${unitId}/meters`, {
    headers: defaultHeaders,
  })
}

export const getQueryExtensions = (clientId: any) => {
  return axios.get(`hu/Client/${clientId}/queryextensions`, {
    headers: defaultHeaders,
  })
}

export const getAdditionalinfo = (unitId: any) =>
  axios.get(`hu/unit/${unitId}/additionalinfo`, {
    headers: defaultHeaders,
  })

export const getNotes = (unitId: any) => {
  return axios.get(`hu/Unit/${unitId}/notes`, {
    headers: defaultHeaders,
  })
}

export const updateNotes = (
  unitId: string,
  body: { notes: string; updatedBy: string }
) => {
  return axios.put(`hu/Unit/${unitId}/notes`, body, {
    headers: defaultHeaders,
  })
}

export const getProxyOwner = (unitId: string) => {
  return axios.get(`hu/Unit/${unitId}/proxyowner`, {
    headers: defaultHeaders,
  })
}

export const getUnitInsuranceCases = (
  filter: IInsuranceCasesFilter
): Promise<AxiosResponse<IInsuranceCasesResultModel>> => {
  return axios.post(`insurance/client/${filter.clientId}/cases`, filter, {
    headers: {
      'x-api-version': '1.0',
    },
  })
}

export const getTenantsInClient = (
  clientId: string,
  filters: ITenantsFilters,
  source?: CancelTokenSource
) => {
  return axios.post(
    `hu/Client/${clientId}/tenants`,
    {
      ...filters,
      sortColumn: filters.sortColumn || TenantsSortFieldEnum.propertyNumber,
      sortorder: filters.sortorder || ISortOrderEnum.asc,
    },
    {
      cancelToken: source?.token,
      headers: defaultHeaders,
    }
  )
}

export const getExcelMetadata = (clientId: string) => {
  return axios.get(`hu/Client/${clientId}/export/metadata`, {
    headers: defaultHeaders,
  })
}

export const downloadUnitListExcel = (query: IExportRequestModel) => {
  return axios.post(
    `hu/Client/${query.unitQuery.clientId}/export/excel`,
    {
      ...query,
    },
    { responseType: 'blob', headers: defaultHeaders }
  )
}

export const getHistoricalOwners = (unitId: string) => {
  return axios.get(`hu/Unit/${unitId}/owners/historical/`, {
    headers: defaultHeaders,
  })
}
